import React from 'react'
import { CampaignChannel, ChannelVariant } from '../../../types/campaigns'
import { CHANNEL_ICONS, CHANNEL_LABELS } from '../../../constants/campaigns'
import {CHECK_MARK, PLUS_SIGN} from '../templateMessages'

interface ChannelTabsProps {
  channels: CampaignChannel[]
  activeChannel: CampaignChannel
  onChannelChange: (channel: CampaignChannel) => void
  variants: ChannelVariant[]
}

export const ChannelTabs: React.FC<ChannelTabsProps> = ({
  channels,
  activeChannel,
  onChannelChange,
  variants,
}) => {
  const hasVariant = (channel: CampaignChannel) => {
    return variants.some((v) => v.channel === channel)
  }

  return (
    <ul className='nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6' role='tablist'>
      {channels.map((channel) => {
        const icon = CHANNEL_ICONS[channel]
        const label = CHANNEL_LABELS[channel]

        const variant = hasVariant(channel)
        const isActive = activeChannel === channel

        return (
          <li key={channel} className='nav-item'>
            <button
              type='button'
              className={`nav-link ${isActive ? 'active' : ''}`}
              onClick={() => onChannelChange(channel)}
              role='tab'
              aria-selected={isActive}
            >
              <span className='me-2'>{icon}</span>
              {label}
              {variant && (
                <span className='badge badge-light-success badge-circle ms-2'>
                  {CHECK_MARK}
                </span>
              )}
              {!variant && (
                <span className='badge badge-light-secondary badge-circle ms-2'>
                  {PLUS_SIGN}
                </span>
              )}
            </button>
          </li>
        )
      })}
    </ul>
  )
}
